export const POST_COVER_IMAGE = 'PUT_COVER_IMAGE'
export const POST_COVER_IMAGE_START = 'PUT_COVER_IMAGE_START'
export const POST_COVER_IMAGE_FAIL = 'PUT_COVER_IMAGE_FAIL'
export const POST_COVER_IMAGE_SUCCESS = 'PUT_COVER_IMAGE_SUCCESS'